import { ApiStatus } from 'Constants';
import axios from 'axios';
import { getSessionObject } from 'Utilities/storage';
import { handleIncorrectPasswordError } from './auth';
import { makePatient } from './seeds/patient';
const validatePassword = password => {
  switch (password) {
    case 'librelibrelibre':
      return {
        status: ApiStatus.BAD_REQUEST,
        response: {
          data: {
            code: ApiStatus.INVALID_DATA_CODE,
            errors: [{
              error: 'context',
              key: 'password'
            }],
            details: 'password.context'
          }
        }
      };
    case '1234password':
      return {
        status: ApiStatus.BAD_REQUEST,
        response: {
          data: {
            code: ApiStatus.INVALID_DATA_CODE,
            errors: [{
              error: 'sequential',
              key: 'password'
            }],
            details: 'password.sequential'
          }
        }
      };
    case 'aaabcpassword':
      return {
        status: ApiStatus.BAD_REQUEST,
        response: {
          data: {
            code: ApiStatus.INVALID_DATA_CODE,
            errors: [{
              error: 'repeat',
              key: 'password'
            }],
            details: 'password.repeat'
          }
        }
      };
    case '123qweasdzxc':
      return {
        status: ApiStatus.BAD_REQUEST,
        response: {
          data: {
            code: ApiStatus.INVALID_DATA_CODE,
            errors: [{
              error: 'dictionary',
              key: 'password'
            }],
            details: 'password.dictionary'
          }
        }
      };
    default:
      return null;
  }
};
const handleRegister = async request => {
  const mockServerUrl = getSessionObject('registerPatient');
  if (mockServerUrl) {
    const resp = await axios.post(mockServerUrl);
    return resp;
  }
  if (!request.data) {
    return {
      status: ApiStatus.BAD_REQUEST,
      message: 'Bad Request'
    };
  }
  const {
    Email,
    Password
  } = request.data;
  if (Email === 'emailexists@abbott.com') {
    return {
      status: ApiStatus.CONFLICT,
      response: {
        data: {
          code: ApiStatus.PATIENT_EXISTS,
          details: 'Patient already exists'
        }
      }
    };
  }
  if (Email === 'hcpaccount@abbott.com') {
    return {
      status: ApiStatus.CONFLICT,
      response: {
        data: {
          code: ApiStatus.FORBIDDEN_HCP_ACCOUNT,
          details: 'HCP user already exists'
        }
      }
    };
  }
  const res = validatePassword(Password);
  if (res) {
    return res;
  }
  return {
    status: ApiStatus.OK
  };
};
const handleUpdatePassword = request => {
  var _request$headers;
  if (!request.data) {
    return {
      status: ApiStatus.BAD_REQUEST,
      message: 'Bad Request'
    };
  }
  const currentPassword = window.atob((_request$headers = request.headers) === null || _request$headers === void 0 ? void 0 : _request$headers.BasicAuth).split(':')[1];
  if (currentPassword === 'incorrect') {
    return handleIncorrectPasswordError();
  }
  const {
    password
  } = request.data;
  if (password === 'sameoldpassword') {
    return {
      status: ApiStatus.BAD_REQUEST,
      response: {
        data: {
          code: ApiStatus.INVALID_DATA_CODE
        }
      }
    };
  }
  const res = validatePassword(password);
  if (res) {
    return res;
  }
  return {
    status: ApiStatus.OK
  };
};
const handleGetPatient = async () => {
  const mockServerUrl = getSessionObject('getPatient');
  if (mockServerUrl) {
    const resp = await axios.get(mockServerUrl);
    return resp;
  }
  return {
    status: ApiStatus.OK,
    data: makePatient()
  };
};
const handleUpdatePatient = () => {
  return {
    status: ApiStatus.OK
  };
};
export const patientHandlers = [{
  match: /patient/,
  handle: handleRegister,
  method: 'POST',
  name: 'registerPatient'
}, {
  match: /patient/,
  handle: handleGetPatient,
  method: 'GET',
  name: 'getPatient'
}, {
  match: /patient/,
  handle: handleUpdatePatient,
  method: 'PUT',
  name: 'updatePatient'
}, {
  match: /password$/,
  handle: handleUpdatePassword,
  method: 'PATCH',
  name: 'updatePassword'
}];